import React, { useState, useEffect, useCallback } from 'react';
import { Table, Space, Select, Input, Button, Tag, message } from 'antd';
import { ReloadOutlined, SearchOutlined, FileAddOutlined } from '@ant-design/icons';
import { useFinanceApi } from '../api/financeApi';
import CreateRequestModal from '../shared/CreateRequestModal';
import { fmtAmount, fmtDate } from '../shared/format';
import { enhanceColumns, toplamGenislik } from '../../ortak/tableHelpers';

const KREDI_TIP = { 1: 'Taksitli', 2: 'Kredi Kartı', 3: 'BCH', 4: 'Diğer', 5: 'Rotatif', 6: 'SPOT' };

export default function KredilerTab({ lookups, perms }) {
  const api = useFinanceApi();
  const p = perms.krediler || {};
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tip, setTip] = useState(null);
  const [search, setSearch] = useState('');
  const [reqRow, setReqRow] = useState(null);

  const load = useCallback(async () => {
    if (p.view === false) return;
    setLoading(true);
    try {
      const params = {};
      if (tip) params.tip = tip;
      if (search) params.genel_arama = search;
      setData(await api.get('/credits', params));
    } catch (e) {
      message.error(e?.response?.data?.detail || 'Krediler yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, [tip, search]);

  useEffect(() => { load(); }, [load]);

  if (p.view === false) return <div style={{ padding: 24 }}>Görüntüleme yetkiniz yok.</div>;

  const columns = [
    { title: 'Firma', dataIndex: 'firma_adi', ellipsis: true },
    { title: 'Banka', dataIndex: 'banka_adi', ellipsis: true },
    { title: 'No', dataIndex: 'no' },
    { title: 'Tip', dataIndex: 'tip', render: (v) => <Tag>{KREDI_TIP[v] || v}</Tag> },
    { title: 'Adı', dataIndex: 'isim', ellipsis: true },
    { title: 'Limit', dataIndex: 'k_limit', render: (v, r) => fmtAmount(v, r.doviz) },
    { title: 'Risk', dataIndex: 'risk', render: (v, r) => fmtAmount(v, r.doviz) },
    { title: 'Taksit', dataIndex: 'taksit_tutar', render: (v, r) => fmtAmount(v, r.doviz) },
    { title: 'Taksit Vade', dataIndex: 'taksit_vade', render: fmtDate },
    { title: 'Bitiş', dataIndex: 'vade_bitis', render: fmtDate },
    {
      title: 'İşlem', key: 'a', fixed: 'right', width: 110,
      render: (_, r) => (
        <Button size="small" icon={<FileAddOutlined />} onClick={() => setReqRow(r)}>Talep</Button>
      ),
    },
  ];

  return (
    <div>
      <Space wrap style={{ marginBottom: 12 }}>
        <Select
          allowClear placeholder="Tip" style={{ width: 150 }} value={tip} onChange={setTip}
          options={Object.entries(KREDI_TIP).map(([v, l]) => ({ value: Number(v), label: l }))}
        />
        <Input allowClear prefix={<SearchOutlined />} placeholder="Ara..." style={{ width: 220 }}
          value={search} onChange={(e) => setSearch(e.target.value)} onPressEnter={load} />
        <Button icon={<ReloadOutlined />} onClick={load}>Yenile</Button>
        <span style={{ color: '#888' }}>{data.length} kayıt</span>
      </Space>
      <Table rowKey="id" size="small" loading={loading} dataSource={data} columns={enhanceColumns(columns)}
        scroll={{ x: toplamGenislik(enhanceColumns(columns)), y: 480 }} pagination={{ pageSize: 50 }} />
      <CreateRequestModal row={reqRow} kind="credits" lookups={lookups}
        onClose={() => setReqRow(null)} onDone={() => setReqRow(null)} />
    </div>
  );
}
